import React, { Component } from 'react';
import './App.css';

import MainPage from './mainpage.js';
import AnimationPage from './animationpage.js';
import CharacterPage from './characterpage.js';
import GraphicPage from './graphicpage.js';
import UXUIPage from './uxuipage.js';

class App extends Component {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);
    const urlPage = urlParams.has('page') && urlParams.get('page') || 'main';

    this.state = { page: urlPage };
  }

  render() {
    const pageChanger = (page) => {
      if (this.state.page !== page) {
        this.setState({ page: page });
        window.history.pushState("", "", `?page=${page}`);
      }
    };

    const getPage = (page) => {
      if (page === "animation") {
        return <AnimationPage changePage={pageChanger}/>;
      } else if (page === "character") {
        return <CharacterPage changePage={pageChanger}/>;
      } else if (page === "graphic") {
        return <GraphicPage changePage={pageChanger}/>;
      } else if (page === "uxui") {
        return <UXUIPage changePage={pageChanger}/>;
      } else {
        return <MainPage changePage={pageChanger}/>;
      }
    }

    return (
      <div className="App">
        {getPage(this.state.page)}
      </div>
    );
  }
}

export default App;
